import { baseApi } from "./baseApi";
import { setMapVersionList } from "../slices/EIPMapValueDefinition.slice";
import { applyMapDetailsToState } from "../../utils/mapDetails";

export const mapsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMapById: builder.query({
      query: ({ mapID }) => `/maps/${mapID}`,
      async onQueryStarted({ moduleName }, { dispatch, queryFulfilled }) {
        try {
          const { data: mapByApiResponse } = await queryFulfilled;
          const data = mapByApiResponse
            ? JSON.parse(JSON.stringify(mapByApiResponse))
            : {};
          if (moduleName !== "clone") {
            applyMapDetailsToState(dispatch, data);
          }
        } catch (e) {
          console.log("execption", e);
        }
      },
    }),
    searchMaps: builder.mutation({
      query: (payload) => ({
        url: "/maps/search",
        method: "POST",
        body: payload,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setMapVersionList(data.records[0].versions));
        } catch (error) {
          console.error(error);
        }
      },
    }),
    createMap: builder.mutation({
      query: (payload) => ({
        url: "/maps",
        method: "POST",
        body: payload,
      }),
    }),
    updateMap: builder.mutation({
      query: ({ selectedMapId, payload }) => ({
        url: `/maps/${selectedMapId}`,
        method: "PATCH",
        body: payload,
      }),
    }),
    updateMapTags: builder.mutation({
      query: ({ selectedMapId, payload }) => ({
        url: `/maps/${selectedMapId}/tag`,
        method: "PATCH",
        body: payload,
      }),
    }),
    bulkOperation: builder.mutation({
      query: ({ mapID, callType, payload }) => ({
        url: `/maps/${mapID}/bulk${callType}`,
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useLazyGetMapByIdQuery,
  useSearchMapsMutation,
  useCreateMapMutation,
  useUpdateMapMutation,
  useUpdateMapTagsMutation,
  useBulkOperationMutation,
} = mapsApi;
